export default __webpack_public_path__ + "static/1-8ba2db196dc2297eeb703a0812807a32.png";